<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/super-admin']"><img src="assets/images/admin/backarrow.png" /> Back to Backenduser Management</a>
   
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="formHeading">
        <h2>Create User</h2>
        <p>Please add the following information to create a new user</p>
    </div>
    <form [formGroup]="userForm">
        <div class="formArea">
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="first_name" [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.first_name.errors">
                        <span *ngIf="f.first_name.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.first_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets are allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                <mat-form-field class="example-full-width">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="last_name" [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.last_name.errors">
                        <!-- <span *ngIf="f.last_name.errors.required" class="text-mute text-danger errorText">This field is required</span> -->
                        <span *ngIf="f.last_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets are allowed</span>
                    </div>
                </div>
            </div>
        <div class="col-12 col-md-6">
            <div class="commanInput">
            <mat-form-field class="example-full-width">
                <mat-label>Email ID</mat-label>
                <input matInput formControlName="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">email already exists</span>
                    </div>
                   <span class="text-mute text-danger errorText" *ngIf="emailError=='Email already exist.'">{{emailError}}</span>
               
        </div>
    </div>
    <div class="col-12 col-md-6">
        <div class="commanInput">
            <mat-form-field class="example-full-width">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="phone" [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"  numbersOnly maxlength = "10" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.phone.errors">
                        <span *ngIf="f.phone.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.phone.errors.pattern" class="text-mute text-danger errorText">Please input valid phone number</span>
                        <span *ngIf="f.phone.errors.minLength" class="text-mute text-danger errorText">Please enter mininmum 10 digit</span>
                        <span *ngIf="f.phone.errors.maxLength" class="text-mute text-danger errorText">Please enter maxmimum 10 digit</span>
                    </div>
                    <span class="text-mute text-danger errorText" *ngIf="phoneError =='Phone already exists.'">{{ phoneError}}</span>
                    <span class="text-mute text-danger errorText" *ngIf="phoneError =='Please input valid phone number'">{{ phoneError}}</span>
        </div>
    </div>
    <div class="col-12 col-md-12">
        <div class="customCheck">
            <div class="row">
                <mat-label>ACCESS</mat-label>
            </div><br>
            <span class="text-mute text-danger errorText" *ngIf="accessError==1">Please give atleast one access</span>
            <!-- <mat-checkbox color="primary"  (change)="onChangeDemo($event,values.user_id,i)" [disabled]="true" [checked]="true" ></mat-checkbox> -->
        <div class="row">
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="backend_user_mgmt" [ngModel]="isCheckeds"  [checked]="false" id="backend_user_mgmt" value="backend_user_mgmt" (change)="onChange($event)">All (Super Admin)</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="user_mgmt_access" [ngModel]="isCheckeds"  [checked]="false" id="user_mgmt_access" value="user_mgmt_access" (change)="onChange($event)">User Management</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="assessment_access" [ngModel]="isCheckeds"  [checked]="false" id="assessment_access" value="assessment_access" (change)="onChange($event)">Manage
                    Assessments</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="course_mgmt_access" [ngModel]="isCheckeds" id="course_mgmt_access" [checked]="false" (change)="onChange($event)" value="course_mgmt_access">Course Management</mat-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="organisation_mgmt_access" [ngModel]="isCheckeds" id="organisation_mgmt_access" [checked]="false" (change)="onChange($event)" value="organisation_mgmt_access"> Organisation Management</mat-checkbox>
            </div>
            <div class="col-3">
              <mat-checkbox color="primary" formControlName="content_authoring_access" [ngModel]="isCheckeds" id="content_authoring_access" [checked]="false" (change)="onChange($event)" value="content_authoring_access">Content Authoring</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="reset_rqsts_access" [ngModel]="isCheckeds" id="reset_rqsts_access" [checked]="false" (change)="onChange($event)" value="reset_rqsts_access">Reset Requests</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="ticket_access" [ngModel]="isCheckeds" id="ticket_access" [checked]="false" (change)="onChange($event)" value="ticket_access"> Manage Tickets</mat-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="reports_access" [ngModel]="isCheckeds" id="reports_access" [checked]="false" value="reports_access" (change)="onChange($event)">Reports</mat-checkbox>
            </div>
            <div class="col-3">
                <mat-checkbox color="primary" formControlName="settings_access" [ngModel]="isCheckeds" id="settings_access" [checked]="false" value="settings_access" (change)="onChange($event)">Settings</mat-checkbox>
            </div>
        </div>
        </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <div class="d-flex w-100 align-items-center justify-content-center">
        <a href="javascript:void(0);" class="backPage ml-2 mr-2" [routerLink]="['/super-admin']">Cancel</a>
        <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="createUser(userForm.value)">Create
            User</a>
        <!-- <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="generateOtp()">Create
            User</a> -->
            <input type="hidden" (click)="open(optMdl)" id="openId">
    </div>
    </div>
    </form>
</div>

<ng-template #optMdl let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Enter OTP</h6>
                <p class="size18">Otp has been sent to your registered Email.</p>

                <mat-form-field class="example-full-width">
                    <mat-label>Enter OTP</mat-label>
                    <input matInput [formControl]="txtOtp" autocomplete="off">
                </mat-form-field> 
               
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                   (click)="createUser(userForm.value)" >Submit</a>
            </div>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
        </div>
    </div>
</ng-template>
<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>
